import axios from 'axios'

import { setupApiInterceptors } from '@/lib/api'

const CHAT_API_URL = String(import.meta.env.VITE_CHAT_API_URL ?? '').replace(/\/+$/, '')

export const chatHttp = axios.create({
  baseURL: CHAT_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

setupApiInterceptors(chatHttp)

export function getChatApiBaseUrl(): string {
  return CHAT_API_URL
}
